// react
import * as React from 'react';

// tanstack
import { useParams } from '@tanstack/react-router';

// material ui icons
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';

// api
import { useGetReportsInWorkspaceQuery } from '@/api/power-bi/powerbiApiSlice';

// relative
import type { NavItemConfig } from '../navigationTypes.ts';

export const useMonitorReportsNavItems = (): NavItemConfig[] => {
  const { accountId } = useParams({ strict: false });
  const { currentData: monitorReports } = useGetReportsInWorkspaceQuery(
    { accountId },
    { skip: !accountId },
  );

  return React.useMemo(() => {
    if (!accountId || !monitorReports?.length) return [];

    return [...monitorReports]
      .sort((a, b) =>
        String(a?.Name ?? '').localeCompare(String(b?.Name ?? '')),
      )
      .map(
        (report) =>
          (({
            id: `monitor-report-${report.Id}`,
            labelKey: report.Name ?? 'Unnamed report',
            iconName: 'chart',
            path: `/$accountId/powerbi/${report.Id}`,
            _icon: <AssessmentRoundedIcon fontSize="small" />
          }) as NavItemConfig & { _icon?: React.ReactNode }),
      );
  }, [accountId, monitorReports]);
};
